import React, { useState } from 'react';
import { Search, ArrowUpRight } from 'lucide-react';
import AddressFinder from '../../AddressFinder';

const JobLocationSection = ({
  formData,
  updateFormField,
  selectedCustomer
}) => {
  const [addressFinderState, setAddressFinderState] = useState({});

  const handleAddressSelect = (addressData) => {
    updateFormField('treatment_address_line1', addressData.address_line1 || '');
    updateFormField('treatment_address_line2', addressData.address_line2 || '');
    updateFormField('treatment_address_city', addressData.address_city || '');
    updateFormField('treatment_address_state', addressData.address_county || '');
    updateFormField('treatment_address_postcode', addressData.address_postcode || '');
    updateFormField('treatment_address_country', addressData.address_country || 'United Kingdom');
  };

  const handleUseCustomerAddress = (e) => {
    const checked = e.target.checked;
    updateFormField('use_customer_address', checked);
    if (checked && selectedCustomer) {
      updateFormField('treatment_address_line1', selectedCustomer.address_line1 || '');
      updateFormField('treatment_address_line2', selectedCustomer.address_line2 || '');
      updateFormField('treatment_address_city', selectedCustomer.address_city || '');
      updateFormField('treatment_address_state', selectedCustomer.address_county || '');
      updateFormField('treatment_address_postcode', selectedCustomer.address_postcode || '');
      updateFormField('treatment_address_country', selectedCustomer.address_country || 'United Kingdom');
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
      <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold text-pest-blue">Treatment Address</h3>
          {addressFinderState.uiState === 'manual' && addressFinderState.switchToAddressSearch && !formData.use_customer_address && (
            <button
              type="button"
              onClick={addressFinderState.switchToAddressSearch}
              className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-pest-teal to-teal-600 text-white border-none rounded-lg text-xs font-semibold cursor-pointer transition-all duration-200 hover:from-teal-600 hover:to-teal-700 hover:shadow-lg"
            >
              <Search size={14} />
              Use Address Lookup
              <ArrowUpRight size={14} />
            </button>
          )}
        </div>
      </div>

      <div className="p-6">
        <div className="space-y-4">
          {/* Use customer address checkbox */}
          {selectedCustomer && selectedCustomer.address_line1 && (
            <label className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded transition">
              <input
                type="checkbox"
                checked={formData.use_customer_address}
                onChange={handleUseCustomerAddress}
                className="w-4 h-4 text-pest-blue border-gray-300 rounded focus:ring-2 focus:ring-pest-blue"
              />
              <span className="ml-3 text-sm">
                <span className="font-medium text-gray-700">Use customer address</span>
                <span className="ml-2 text-gray-500 text-xs">
                  ({selectedCustomer.address_line1}, {selectedCustomer.address_postcode})
                </span>
              </span>
            </label>
          )}

          {formData.use_customer_address && selectedCustomer ? (
            <div className="bg-gradient-to-r from-green-50 to-green-100 p-4 rounded-lg border border-green-200">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <svg className="w-5 h-5 text-green-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                  </svg>
                </div>
                <div className="ml-3 flex-1">
                  <p className="text-sm font-semibold text-green-900 mb-1">Using Customer Address</p>
                  <div className="text-sm text-green-800 space-y-0.5">
                    {selectedCustomer.address_line1 && <div>{selectedCustomer.address_line1}</div>}
                    {selectedCustomer.address_line2 && <div>{selectedCustomer.address_line2}</div>}
                    {selectedCustomer.address_city && <div>{selectedCustomer.address_city}</div>}
                    {selectedCustomer.address_county && <div>{selectedCustomer.address_county}</div>}
                    {selectedCustomer.address_postcode && <div>{selectedCustomer.address_postcode}</div>}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <AddressFinder
              initialAddress={{
                address_line1: formData.treatment_address_line1 || '',
                address_line2: formData.treatment_address_line2 || '',
                address_city: formData.treatment_address_city || '',
                address_county: formData.treatment_address_state || '',
                address_postcode: formData.treatment_address_postcode || '',
                address_country: formData.treatment_address_country || 'United Kingdom'
              }}
              onAddressSelect={handleAddressSelect}
              onStateChange={setAddressFinderState}
              showManualEntry={true}
              autoSelectSingle={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default JobLocationSection;
